export default __webpack_public_path__ + "static/media/lalupita.14ec4ee8.jpg";